const styles = theme => ({
  rootStyle: {
    width: '100%',
    maxWidth: 1200,
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 1270px)': {
      gap: '20px', // veya istediğiniz gap değeri
    },
  },
  gridItemStart: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  gridItemCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  gridItemEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
})

export default styles
